export default __webpack_public_path__ + "static/media/qualifications-active.b069ed0f.svg";